
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


document.addEventListener('DOMContentLoaded', function() {
    waitForElm('.singleProductPreOrderForm').then((elm) => {
        elm.closest('.hc-qty-buy-row').classList.add('hc-qty-buy-row--pre-order');
    });

    // waitForElm('.product-grid__content .stamped-product-reviews-badge').then((elm) => {
    //     let starRating = elm;
    //     let pdpInfoRow = document.querySelector('.hc-pro-info-row');
        
    //     pdpInfoRow.insertBefore(starRating, pdpInfoRow.firstChild);
    // });
});


(function() {
  const MAX_VISIBLE = 5;

  function initToggle(container) {
    if (!container || container.dataset.tagsInit === "true") return;

    const tags = container.querySelectorAll(".product-tag");
    const toggleButton = container.querySelector(".tags-toggle");
    if (!toggleButton) return;

    const hiddenTags = Array.from(tags).slice(MAX_VISIBLE);
    if (!hiddenTags.length) {
      toggleButton.style.display = "none";
      return;
    }

    // Initial button state
    toggleButton.textContent = "+ See More";
    toggleButton.classList.remove("expanded");

    toggleButton.addEventListener("click", () => {
      const expanded = toggleButton.classList.contains("expanded");

      hiddenTags.forEach(tag => {
        tag.style.display = expanded ? "none" : "inline-block";
      });

      toggleButton.textContent = expanded ? "+ See More" : "- See Less";
      toggleButton.classList.toggle("expanded");
    });

    container.dataset.tagsInit = "true";
  }

  // Initialize all existing containers
  function initAll() {
    document.querySelectorAll(".product-tags-container").forEach(initToggle);
  }

  // Observe for dynamically added tags containers (e.g., in modals)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains("product-tags-container")) {
            initToggle(node);
          } else {
            const found = node.querySelectorAll
              ? node.querySelectorAll(".product-tags-container")
              : [];
            found.forEach(initToggle);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
